import React from 'react';
import {useIntl} from 'react-intl';

import {Button} from '@views/Account/Plan/_components/ActionButtons';
import {PanelChangePlan} from './PanelChangePlan';
import {useView} from '@views/Account/Plan/_hooks/useView';

const TEXT = {
  BUTTON_MODIFY_PLAN: {id: 'account_yourPlan.planPanel.modifyPlan'},
};

interface ActionChangePlanProps {
  onSuccess: () => Promise<void>;
}

export const ActionChangePlan: React.FC<ActionChangePlanProps> = ({onSuccess}) => {
  const {formatMessage} = useIntl();
  const {visible, open, close} = useView();

  return (
    <>
      <Button onPress={open}>{formatMessage(TEXT.BUTTON_MODIFY_PLAN)}</Button>
      <PanelChangePlan isVisible={visible} onBack={close} onSuccess={onSuccess} onClose={close} />
    </>
  );
};
